import { render, staticRenderFns } from "./outboundHistory.vue?vue&type=template&id=2011d54e&scoped=true&"
import script from "./outboundHistory.vue?vue&type=script&lang=js&"
export * from "./outboundHistory.vue?vue&type=script&lang=js&"
import style0 from "./outboundHistory.vue?vue&type=style&index=0&id=2011d54e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2011d54e",
  null
  
)

export default component.exports